import { Reveal, Overline } from "../Reveal";
import { Link } from "react-router-dom";
import { WHITELABEL_POINTS } from "../../data/content";
import IconTile from "../IconTile";

export default function WhiteLabel() {
  return (
    <section
      id="whitelabel"
      data-testid="whitelabel-section"
      className="relative py-24 md:py-32 border-t border-[#E6E9F1] overflow-hidden bg-[#F4F6FB]"
    >
      <div className="mb-blob mb-blob-blue mb-anim-b w-[360px] h-[360px] top-10 -right-24" />
      <div className="absolute inset-0 mb-grid-lines opacity-60" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-8">
        <div className="grid gap-14 lg:grid-cols-2 lg:items-center">
          {/* Copy */}
          <Reveal>
            <Overline>Introducing Agency OS</Overline>
            <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tighter leading-none text-[#0B1533]">
              Your own white-label SaaS,{" "}
              <span className="text-[#FF6B00]">launched this week.</span>
            </h2>
            <p className="mt-5 text-base md:text-lg text-[#475569] leading-relaxed">
              One dashboard holds every MagicBolt product. You sell it under your brand,
              domain and prices. We stay invisible; you own the client and the margin.
            </p>

            <ul className="mt-8 grid gap-4 sm:grid-cols-2">
              {WHITELABEL_POINTS.map((p) => (
                <li
                  key={p.title}
                  className="group rounded-2xl border border-[#E6E9F1] bg-white p-5 mb-card-shadow transition-all duration-300 hover:-translate-y-1 hover:border-[#FF6B00]/30 hover:shadow-[0_16px_36px_rgba(255,107,0,0.12)]"
                >
                  <IconTile icon={p.icon} />
                  <h3 className="mt-4 text-base font-bold text-[#0B1533]">{p.title}</h3>
                  <p className="mt-1.5 text-sm text-[#475569] leading-relaxed">{p.desc}</p>
                </li>
              ))}
            </ul>

            <Link
              to="/agency-os"
              data-testid="explore-whitelabel-link"
              className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[#FF6B00] hover:gap-3 transition-all"
            >
              Explore the white-label platform
              <span aria-hidden>→</span>
            </Link>
          </Reveal>

          {/* Product visual */}
          <Reveal delay={0.15}>
            <div data-testid="whitelabel-mockup" className="relative mx-auto max-w-[560px]">
              <div
                aria-hidden
                className="pointer-events-none absolute -inset-8 rounded-[48px] bg-[#FF6B00] blur-3xl opacity-[0.12]"
              />
              <img
                src="/white-label-magicbolt.webp"
                alt="Agency OS - your white-label AI SaaS dashboard, fully branded"
                width="1260"
                height="1260"
                loading="lazy"
                decoding="async"
                className="relative block w-full h-auto object-contain drop-shadow-[0_28px_50px_rgba(11,21,51,0.16)]"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
